import { CheckOutlined } from '@ant-design/icons'
import { Button, Col, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { HTMLText, Img } from '../common/'
import Tile from '../Tile'
const { Title } = Typography

const License = ({ selected, name, best_option, onClick }) => {
  const { t } = useTranslation()
  return (
    <Col className={'license ' + selected}>
      <Tile
        title={t(`Royalties.${name}`)}
        recomended={best_option}
        bordered={selected}
      >
        <Title level={3}>{t(`Royalties.${name}.description`)}</Title>
        {'acquisition' === name || 'free_ebook' === name ? (
          <Img
            className="tile-icon"
            height="125px"
            style={{ padding: '26px 26px 21px' }}
            src={`images/contract/${name}.svg`}
          />
        ) : (
          <Img
            className="tile-icon"
            src={'images/contract/license.webp'}
            style={{ paddingBottom: '8px' }}
          />
        )}
        <HTMLText html={t(`Royalties.${name}.text`)} className="license-text" />
        {selected ? (
          <Button type="primary" block>
            {t('Royalties.Selected.button')}
            <CheckOutlined />
          </Button>
        ) : (
          <Button block onClick={onClick}>
            {t('Royalties.NotSelected.button')}
          </Button>
        )}
      </Tile>
    </Col>
  )
}
export default License
